import { Injectable } from "@angular/core";
import snsWebSdk from "@sumsub/websdk";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { switchMap } from "rxjs/operators";
import { UserService } from "./user.service";

@Injectable({ providedIn: "root" })
export class KycService {
  constructor(
    private _userService: UserService,
    private _toastService: ToastrService,
  ) {}

  private _getNewAccessToken() {
    return lastValueFrom(
      this._userService.generateKycSdkToken().pipe(switchMap((response) => response.accessToken)),
    );
  }

  public launchWebSdk(accessToken: string, userInfo: { email: string; phone: string }) {
    const snsWebSdkInstance = snsWebSdk
      .init(accessToken, () => this._getNewAccessToken())
      .withConf({ lang: "en", email: userInfo.email, phone: userInfo.phone })
      .withOptions({ addViewportTag: true, adaptIframeHeight: true })
      .on("idCheck.onError", (error) => this._toastService.error(error.error))
      .build();

    snsWebSdkInstance.launch("#sumsub-websdk-container");
  }
}
